import React, { useState, useEffect, useContext } from "react";
import { useLocation, Redirect } from "react-router-dom";
import { StoreContext } from "components/StoreContext";
import { debug } from "helpers";
import Loading from "components/Loading";

const OldStoreRedirects = () => {
  const [next, setNext] = useState(null);
  const { store, StoreAPI, config } = useContext(StoreContext);
  const { pathname, search } = useLocation();
  const previous = `${pathname.substr(1)}${search}`;

  useEffect(() => {
    if (config.loaded && store.loaded && next === null) {
      StoreAPI.get(`Seo/RedirectUrl?RedirectFrom=${previous}`)
        .then(response => {
          if (response.data.redirectTo) {
            setNext(`${response.data.redirectTo}`);
          } else {
            setNext("/");
          }
        })
        .catch(err => {
          debug(err);
          setNext("/");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.loaded, store.loaded, next]);

  if (config.loaded && store.loaded && next !== null) {
    return <Redirect to={next} />;
  }

  return (
    <div className="site__loading">
      <Loading bg="transparent" />
    </div>
  );
};

export default OldStoreRedirects;
